import Model from '../orm/Model'
import Input from '../orm/Input'

import { isEmpty } from '@/utilities'

import Role from './Role'
import Course from './Course'
import UserCourse from './UserCourse'
import Event from './Event'
import UserEvent from './UserEvent'
import Team from './Team'
import UserTeam from './UserTeam'
import Student from './Student'
import UserStudent from './UserStudent'

export default class User extends Model {

    static entity = 'users'

    static fields() {
        return {
            id: this.increment(),
            first_name: this.attr(''),
            last_name: this.attr(''),
            email: this.attr(''),
            phone_number: this.attr(null),
            prefers_sms: this.boolean(),
            active: this.boolean(),
            late_email: this.number(),
            absent_email: this.number(),
            pindrop_email: this.boolean(),
            daily_recap_email: this.boolean(),
            weekly_startup_email: this.boolean(),
            weekly_recap_email: this.boolean(),
            alert_filter: this.attr([]),
            role_id: this.attr(null),
            role: this.belongsTo(Role, 'role_id'),
            assignedCourses: this.belongsToMany(
                Course, 
                UserCourse, 
                'user_id', 
                'course_id'
            ),
            assignedEvents: this.belongsToMany(
                Event,
                UserEvent,
                'user_id',
                'event_id'
            ),
            assignedTeams: this.belongsToMany(
                Team,
                UserTeam,
                'user_id',
                'team_id'
            ),
            assignedStudents: this.belongsToMany(
                Student,
                UserStudent,
                'user_id',
                'student_id'
            )
        }
    }

    static graphql = {
        all: {
            paginated: true,
            parameters: {
                page: 'Int',
                sort_by: 'String',
                sort_dir: 'String',
                relation: 'String',
                relation_uuid: 'String',
                state: 'String'
            },
            include: { 
                role: true, 
                assignedTeams: true,
                assignedCourses: true
            }
        },
        relation: {
            paginated: true,
            parameters: {
                page: 'Int',
                sort_by: 'String',
                sort_dir: 'String',
                relation: 'String',
                relation_uuid: 'String'
            },
            include: { role: true }
        },
        params: {
            paginated: true,
            parameters: {
                query: 'String',
                per_page: 'Int'
            }
        },
        one: {
            type: 'user',
            parameters: {
                id: 'Int!'
            },
            include: {
                role: true,
                assignedCourses: {
                    location: true
                },
                assignedEvents: {
                    location: true
                },
                assignedTeams: true,
                assignedStudents: true
            },
            exclude: {
                assignedEvents: [ 
                    'attending_count',
                    'waitlist_count'
                ]
            }
        },
        update: {
            type: 'updateUser',
            parameters: {
                input: new Input('UserInput!', [
                    'id', 
                    'role_id', 
                    'first_name', 
                    'last_name', 
                    'phone_number',
                    'email',
                    'prefers_sms',
                    'alert_filter',
                    'late_email',
                    'absent_email',
                    'tardy_absent_email', 
                    'pindrop_email', 
                    'daily_recap_email',
                    'weekly_recap_email', 
                    'weekly_startup_email',
                    'higher_contrast'
                ])
            }
        },
        remove: {
            type: 'removeUser',
            parameters: {
                id: 'Int!'
            }
        },
        invite: {
            type: 'inviteUser',
            parameters: {
                first_name: 'String!',
                last_name: 'String',
                role_id: 'Int!',
                email: 'String!'
            }
        },
        switch: {
            type: 'switchUser',
            parameters: {
                user_id: 'Int!'
            },
            include: { role: true }
        },
        password: {
            type: 'updatePassword',
            parameters: {
                user_id: 'Int!',
                current_password: 'String!',
                new_password: 'String!'
            }
        }
    }

    static async $search(query, per_page = 5) {
        if (isEmpty(query)) return

        const { data } = await this.$fetch({
            graphql: 'params',
            variables: {
                query,
                per_page
            }
        })

        return data
    }
}